(function($){

	$(document).ready(function(){

		$('#videoModal').on('show.bs.modal',function(e){
			$video_src = e.relatedTarget.getAttribute('data-video-src');
			$('#videoModal').find('#video-container').html('<video src="' + $video_src + '" class="video" controls preload="auto" playsinline controlsList="nodownload"></video>');
			$video = this.querySelector('.video');
			$video.play();
		});

		$('#videoModal').on('shown.bs.modal',function(e){
			
		});

		$('#videoModal').on('hidden.bs.modal',function(e){
			$('#videoModal').find('#video-container').find('video').remove();
		});

	});
	
})(jQuery);